import styled from 'styled-components';
import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4Small } from '../../constants';

export const TotalRateStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;

  /* Prevent horizontal shift between cards by setting a minimum width for labels in the top-right header */
  min-width: 17rem;

  ${breakpointsMQ4Small} {
    align-items: flex-start;
  }
`;

export const RateTitleStyled = styled.span`
  ${typography.capsRegular[14]}
  line-height: 1.6rem;
  color: ${colors.neutral[900]};
  text-align: right;
`;

export const RateValueStyled = styled.span`
  ${typography.bold[14]}
  color: ${colors.green[600]};
  text-align: right;
  cursor: default;
`;

export const ApproxStyled = styled.span`
  font-size: 1.6rem;
`;
